var map = {
	"./icon_citizens_wellbeing_perception.svg": "7c75",
	"./icon_ecosystem_services.svg": "1673",
	"./icon_hydraulic_risk_reduction_level.svg": "96c4",
	"./icon_long_economic_availability.svg": "3176",
	"./icon_short_economic_availability.svg": "d65f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8fc";